import React, { Component } from 'react';
import ColorItem from './color-Item';
import { IEditItem } from './textEditDataProcesser';
import styles from './index.css';
import COLOR_MORE_ICON from '@tencent/docs-design-resources/icon/mobile/svg/palette_regular_24.svg';
import { ColorPanelType } from '@com-m/edit-panel-m/const';
import { IColorPickerManager } from '@src/slide/application/service/color-picker-manager/color-picker-manager.interface';

interface IColorBaseItemProps {
    id: string | undefined;
    data: Array<IEditItem> | undefined;
    value: string | undefined;
    title: string;
    disabled: boolean | undefined;
    showNoColor?: boolean;
    colorPanelType: ColorPanelType;
    colorPickerManager?: IColorPickerManager;
    openColorPanel(): void;
}

interface IColorBaseItemStates {
    colorValue: string | undefined;
}

export default class ColorBaseItem extends Component<IColorBaseItemProps, IColorBaseItemStates> {
    public constructor(props) {
        super(props);
        this.state = {
            colorValue: props.value?.substr(0, 7) || '',
        };
    }

    // eslint-disable-next-line react/no-deprecated
    public componentWillReceiveProps(nextProps) {
        const colorValue = nextProps.value?.substr(0, 7);
        if (colorValue !== this.state.colorValue) {
            this.setState({
                colorValue,
            });
        }
    }

    public setSelectedColor = (colorValue) => {
        this.setState({
            colorValue,
        });
    };

    public render() {
        const { id, data, value, title, disabled, showNoColor } = this.props;
        return <div className={styles['color-edit-container']}>
            <div className={styles['text-item-title']}>{title}</div>
            <div className={styles['color-item-container-wrapper']}>
                <div className={styles['color-item-container']}>
                    {
                        data?.map((item, index) => <ColorItem
                            colorPickerManager={this.props.colorPickerManager}
                            key={item.defaultValue}
                            selected={item.selected
                                || this.formatColor(item.defaultValue) === this.formatColor(this.state.colorValue)
                                || (!this.state.colorValue && !!showNoColor && index === 0)
                            }
                            disabled={disabled}
                            id={id}
                            defaultValue={item.defaultValue}
                            value={value}
                            showFirstNoColorIcon={showNoColor && index === 0}
                            setSelectedColor={this.setSelectedColor}

                        />)
                    }
                </div>
                {
                    <div
                        onClick={this.props.openColorPanel}
                        className={styles['color-panel-button']}>
                        <div className={styles['color-panel-button-inner']} style={{
                            backgroundImage: `url(${COLOR_MORE_ICON})`,
                        }} />
                    </div>
                }
            </div>
        </div>;
    }

    private formatColor(color?: string) {
        return color?.toUpperCase().slice(0, 7);
    }
}

